import { Injectable } from '@angular/core';
import { ProductServiceInterface } from '@app/models/interfaces/product-service.interface';
import { TaqmanSearchResponseInterface } from '@app/models/responses/taqman-search-response.interface';
import { MicrornaArrayProductInterface } from '@app/products/microrna/microrna-array/models/interfaces/microrna-array-product.interface';

@Injectable({providedIn: 'root'})
export class MicrornaArrayProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): MicrornaArrayProductInterface[] {

        return searchResult.products.map((product) => {

            const newProduct: MicrornaArrayProductInterface = {
                ...product,
                selectedAvailability: product.availability, // preselect
                selectedCatalogNumber: product.defaultCatalogNum, // preselect
                taqmanProductID: product.productID // unique ID for the UI
            }

            return newProduct;

        });

    }

}
